import {IMuWidget} from "./IMuWidget";

export class AccountRolesField extends IMuWidget
{
	beforeIndex() {
		const childCount = this.container.childElementCount;
		if (childCount > 1) {
			// const names =
			this.container.innerHTML += '<span class="account-roles__count-info">+' + (childCount - 1) + '</span>';
		}
	}

	container_click() {
		this.container.classList.toggle('account-roles--collapsed');
	}
}